"use client";

import React, {useState, lazy} from "react";
import { BANKER, LOCATION } from "@/contants";
const NoData = lazy(() => import("@/components/client/NoData"));

const OddTableAnalysis = ({ matchId, companyId, type, data, dataLiveOdd }) => {
  const [location, setLocation] = useState(LOCATION[0]);
  const groupByCompanyId = (data) => {
    const grouped = data.reduce((acc, item) => {
      const companyId = item.companyId;
      item.changeTime = Number(item.changeTime); // Chuyển đổi changeTime sang số

      // Nếu chưa có nhóm cho companyId này, thêm vào
      if (!acc[companyId]) {
        acc[companyId] = item;
      } else {
        // So sánh changeTime, giữ lại item có changeTime lớn hơn (gần hiện tại hơn)
        if (item.changeTime > acc[companyId].changeTime) {
          acc[companyId] = item;
        }
      }
      return acc;
    }, {});

    // Trả về mảng các giá trị
    return Object.values(grouped);
  };

  const filterCompanyId = (companyId, data) => {
    return data.find((item) => item.companyId === companyId);
  };

  const handleChangeLocation = (item) => {
    setLocation(item);
  };
  return (
    data ? (
      <div>
        <div className="flex my-2 @lg:hidden">
          {LOCATION.map((item) => (
            <div
              key={item.slug}
              onClick={() => {
                handleChangeLocation(item);
              }}
              className={`${
                location.slug === item.slug
                  ? "bg-button-blue-bet text-[#FFFFFF]"
                  : "bg-header-blue text-blur-gray"
              } mr-1 font-xs font-semi-bold rounded-full px-2 py-1 hover:cursor-pointer`}
            >
              Tỉ lệ {item.name}
            </div>
          ))}
        </div>
        <div className="hidden @lg:block">
          <table
            width="100%"
            border="0"
            cellpadding="0"
            cellspacing="0"
            className="team-table-other"
          >
            <tbody>
              <tr height="100%" className="border border-[#FFFFFF] [&>*]:bg-[#E6ECEE] [&>*]:dark:bg-pure-black">
                <th
                  rowspan="2"
                  width="15%"
                  height="24"
                  className="border border-[#FFFFFF] "
                >
                  <b>Nhà cái</b>
                </th>
                <th
                  rowspan="2"
                  colSpan={1}
                  width="5%"
                  className="border border-[#FFFFFF]"
                >
                  #
                </th>
                <th colSpan="3" className="border border-[#FFFFFF] p-2">
                  <b>Tỷ lệ châu Á</b>
                </th>
                <th colSpan="3" className="border border-[#FFFFFF]">
                  <b>Tỷ lệ Tài Xỉu</b>
                </th>
                <th colSpan="3" className="border border-[#FFFFFF]">
                  <b>Tỷ lệ châu Âu</b>
                </th>
              </tr>
              <tr height="20" className="border border-[#FFFFFF]">
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF] p-1">
                  Chủ
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  HDC
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Khách
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Tài
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Kèo đấu
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Xỉu
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Chủ
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Hòa
                </th>
                <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                  Khách
                </th>
              </tr>
              {BANKER.map((item, index) => {
                const handicapOdd = data.handicap.find(
                  (odd) => odd.companyId === item.value
                );

                const overUnderOdd = data.overUnder.find(
                  (odd) => odd.companyId === item.value
                );

                const europeOdd = data.europeOdds.find(
                  (odd) => odd.companyId === item.value
                );
                const handicapLiveOdds = filterCompanyId(
                  item.value,
                  groupByCompanyId(dataLiveOdd.liveHandicapOdds)
                );
                const overUnderLiveOdds = filterCompanyId(
                  item.value,
                  groupByCompanyId(dataLiveOdd.liveOverUnderOdds)
                );
                const europeLiveOdds = filterCompanyId(
                  item.value,
                  groupByCompanyId(dataLiveOdd.liveEuropeOdds)
                );

                return (
                  <React.Fragment key={index}>
                    <tr className={(index+1)  % 2 !== 0 ? 'bg-[#FFFFFF] dark:bg-pure-black' : 'bg-[#E6ECEE] dark:bg-dark-slate'}
                        style={{height: "20px"}}
                    >
                      <td className="companyBg text-center" rowSpan={3}>
                        <b>{item.name}</b>
                      </td>
                      <td className="ll rl lo-f2 text-center p-1">
                        {" "}
                        Sớm
                      </td>
                      <td className="hbg-td2r text-center font-semi-bold bg-pale-aqua dark:bg-pale-dark-aqua" >
                        {handicapOdd?.initialHome}
                      </td>
                      <td className="hbg-td2r text-center font-semi-bold  bg-pale-aqua  dark:bg-pale-dark-aqua" data-o="0">
                        {handicapOdd?.initialAway}
                      </td>
                      <td
                        className="rl hbg-td2r text-center font-semi-bold  bg-pale-aqua  dark:bg-pale-dark-aqua"
                        name="oddsData"
                        data-o="1.35"
                      >
                        {handicapOdd?.instantHandicap}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold  bg-yellow-pastel  dark:bg-yellow-dark-pastel"
                        name="oddsData"
                        data-o="9.40"
                        data-e="1"
                      >
                        {overUnderOdd?.initialOver}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold bg-yellow-pastel  dark:bg-yellow-dark-pastel"
                        name="oddsData"
                        data-o="1.07"
                        data-e="1"
                      >
                        {overUnderOdd?.instantHandicap}
                      </td>
                      <td
                        className="hbg-td1r rl text-center font-semi-bold bg-yellow-pastel dark:bg-yellow-dark-pastel"
                        name="oddsData"
                        data-o="12.50"
                        data-e="1"
                      >
                        {overUnderOdd?.initialUnder}
                      </td>
                      <td
                        className="hbg-td4r text-center font-semi-bold bg-cool-mist dark:bg-cool-dark-mist"
                        name="oddsData"
                        data-o="4.54"
                      >
                        {europeOdd?.initialHome}
                      </td>
                      <td className="hbg-td4r text-center font-semi-bold bg-cool-mist dark:bg-cool-dark-mist" data-o="4.5">
                        {europeOdd?.initialDraw}
                      </td>
                      <td
                        className="rl hbg-td4r text-center font-semi-bold bg-cool-mist dark:bg-cool-dark-mist"
                        name="oddsData"
                        data-o="0.08"
                      >
                        {europeOdd?.initialAway}
                      </td>
                    </tr>
                    <tr className={(index+1)  % 2 !== 0 ? 'bg-[#FFFFFF] dark:bg-pure-black' : 'bg-[#E6ECEE] dark:bg-dark-slate'}
                        style={{height: "20px"}}
                    >

                      <td className="ll rl lo-f2 text-center p-1">
                        {" "}
                        Cuối
                      </td>
                      <td
                        className="hbg-td2r text-center font-semi-bold  bg-pale-aqua  dark:bg-pale-dark-aqua"
                        name="oddsData"
                        data-o="0.58"
                      >
                        {handicapOdd?.instantHome}
                      </td>
                      <td className="hbg-td2r text-center font-semi-bold  bg-pale-aqua  dark:bg-pale-dark-aqua" data-o="0">
                        {handicapOdd?.instantHandicap}
                      </td>
                      <td
                        className="rl hbg-td2r text-center font-semi-bold  bg-pale-aqua  dark:bg-pale-dark-aqua"
                        name="oddsData"
                        data-o="1.35"
                      >
                        {handicapOdd?.instantAway}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold bg-yellow-pastel dark:bg-yellow-dark-pastel"
                        name="oddsData"
                        data-o="9.40"
                        data-e="1"
                      >
                        {overUnderOdd?.instantOver}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold bg-yellow-pastel dark:bg-yellow-dark-pastel"
                        name="oddsData"
                        data-o="1.07"
                        data-e="1"
                      >
                        {overUnderOdd?.instantHandicap}
                      </td>
                      <td
                        className="hbg-td1r rl text-center font-semi-bold bg-yellow-pastel dark:bg-yellow-dark-pastel"
                        name="oddsData"
                        data-o="12.50"
                        data-e="1"
                      >
                        {overUnderOdd?.instantUnder}
                      </td>
                      <td
                        className="hbg-td4r text-center font-semi-bold bg-cool-mist dark:bg-cool-dark-mist"
                        name="oddsData"
                        data-o="4.54"
                      >
                        {europeOdd?.instantHome}
                      </td>
                      <td className="hbg-td4r text-center font-semi-bold bg-cool-mist dark:bg-cool-dark-mist" data-o="4.5">
                        {europeOdd?.instantDraw}
                      </td>
                      <td
                        className="rl hbg-td4r text-center font-semi-bold bg-cool-mist dark:bg-cool-dark-mist"
                        name="oddsData"
                        data-o="0.08"
                      >
                        {europeOdd?.instantAway}
                      </td>
                    </tr>
                    <tr className={(index+1)  % 2 !== 0 ? 'bg-[#FFFFFF] dark:bg-pure-black' : 'bg-[#E6ECEE] dark:bg-dark-slate'}
                        style={{height: "20px"}}
                    >

                      <td className="ll rl lo-f2 text-vibrant-red text-center p-1">
                        {" "}
                        Run
                      </td>
                      <td
                        className="hbg-td2r text-center font-semi-bold"
                        name="oddsData"
                        data-o="0.58"
                      >
                        {handicapLiveOdds?.instantHome}
                      </td>
                      <td className="hbg-td2r text-center font-semi-bold" data-o="0">
                        {handicapLiveOdds?.instantHandicap}
                      </td>
                      <td
                        className="rl hbg-td2r text-center font-semi-bold"
                        name="oddsData"
                        data-o="1.35"
                      >
                        {handicapLiveOdds?.instantAway}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold"
                        name="oddsData"
                        data-o="9.40"
                        data-e="1"
                      >
                        {overUnderLiveOdds?.instantOver}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold"
                        name="oddsData"
                        data-o="1.07"
                        data-e="1"
                      >
                        {overUnderLiveOdds?.instantHandicap}
                      </td>
                      <td
                        className="hbg-td1r rl text-center font-semi-bold"
                        name="oddsData"
                        data-o="12.50"
                        data-e="1"
                      >
                        {overUnderLiveOdds?.instantUnder}
                      </td>
                      <td
                        className="hbg-td4r text-center font-semi-bold"
                        name="oddsData"
                        data-o="4.54"
                      >
                        {europeLiveOdds?.instantHome}
                      </td>
                      <td className="hbg-td4r text-center font-semi-bold" data-o="4.5">
                        {europeLiveOdds?.instantDraw}
                      </td>
                      <td
                        className="rl hbg-td4r text-center font-semi-bold"
                        name="oddsData"
                        data-o="0.08"
                      >
                        {europeLiveOdds?.instantAway}
                      </td>
                    </tr>
                    {/* <tr
                      bgcolor="#FFFFFF"
                      style={{ height: "20px" }}
                      className="odds"
                      id="tr_o_2_31"
                      name="liveOdds"
                    >
                      <td className="ll rl lo-f text-center p-1"> Cuối</td>
                      <td
                        className="hbg-td2 bg-pale-aqua text-center font-semi-bold"
                        name="oddsData"
                        data-o="0.64"
                      >
                        {handicapOdd?.instantHome || "-"}
                      </td>
                      <td
                        className="hbg-td2 bg-pale-aqua text-center font-semi-bold"
                        data-o="0.5/1"
                      >
                        {handicapOdd?.instantHandicap || "-"}
                      </td>
                      <td
                        className="rl hbg-td2 bg-pale-aqua text-center font-semi-bold"
                        name="oddsData"
                        data-o="1.19"
                      >
                        {handicapOdd?.instantAway || "-"}
                      </td>
                      <td
                        className="hbg-td1 text-center bg-yellow-pastell font-semi-bold"
                        name="oddsData"
                        data-o="1.46"
                        data-e="1"
                      >
                        {overUnderOdd?.instantOver || "-"}
                      </td>
                      <td
                        className="hbg-td1 text-center bg-yellow-pastell font-semi-bold"
                        name="oddsData"
                        data-o="3.87"
                        data-e="1"
                      >
                        {overUnderOdd?.instantHandicap || "-"}
                      </td>
                      <td
                        className="hbg-td1 rl text-center bg-yellow-pastell font-semi-bold"
                        name="oddsData"
                        data-o="4.77"
                        data-e="1"
                      >
                        {overUnderOdd?.instantUnder || "-"}
                      </td>
                      <td
                        name="oddsData"
                        className="text-center bg-cool-mist font-semi-bold"
                        data-o="0.69"
                      >
                        {europeOdd?.instantHome || "-"}
                      </td>
                      <td
                        data-o="2.5/3"
                        className="text-center bg-cool-mist font-semi-bold"
                      >
                        {europeOdd?.instantDraw || "-"}
                      </td>
                      <td
                        className="rl text-center bg-cool-mist font-semi-bold"
                        name="oddsData"
                        data-o="1.12"
                      >
                        {europeOdd?.instantAway || "-"}
                      </td>
                    </tr> */}
                    {/* <tr
                      bgcolor="#FFFFFF"
                      style={{ height: "20px" }}
                      className="odds"
                      id="tr_o_3_31"
                      name="runOdds"
                    >
                      <td className="ll rl lo-f2 text-vibrant-red text-center p-1">
                        {" "}
                        Run
                      </td>
                      <td
                        className="hbg-td2r text-center font-semi-bold"
                        name="oddsData"
                        data-o="0.58"
                      >
                        {handicapLiveOdds?.instantHome}
                      </td>
                      <td className="hbg-td2r text-center font-semi-bold" data-o="0">
                        {handicapLiveOdds?.instantHandicap}
                      </td>
                      <td
                        className="rl hbg-td2r text-center font-semi-bold"
                        name="oddsData"
                        data-o="1.35"
                      >
                        {handicapLiveOdds?.instantAway}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold"
                        name="oddsData"
                        data-o="9.40"
                        data-e="1"
                      >
                        {overUnderLiveOdds?.instantOver}
                      </td>
                      <td
                        className="hbg-td1r text-center font-semi-bold"
                        name="oddsData"
                        data-o="1.07"
                        data-e="1"
                      >
                        {overUnderLiveOdds?.instantHandicap}
                      </td>
                      <td
                        className="hbg-td1r rl text-center font-semi-bold"
                        name="oddsData"
                        data-o="12.50"
                        data-e="1"
                      >
                        {overUnderLiveOdds?.instantUnder}
                      </td>
                      <td
                        className="hbg-td4r text-center font-semi-bold"
                        name="oddsData"
                        data-o="4.54"
                      >
                        {europeLiveOdds?.instantHome}
                      </td>
                      <td className="hbg-td4r text-center font-semi-bold" data-o="4.5">
                        {europeLiveOdds?.instantDraw}
                      </td>
                      <td
                        className="rl hbg-td4r text-center font-semi-bold"
                        name="oddsData"
                        data-o="0.08"
                      >
                        {europeLiveOdds?.instantAway}
                      </td>
                    </tr> */}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="@lg:hidden">
          <table
            width="100%"
            border="0"
            cellpadding="0"
            cellspacing="0"
            className="team-table-other"
          >
            <tbody>
            <tr height="100%" className="border border-[#FFFFFF] bg-[#E6ECEE] dark:bg-pure-black">
              <th
                rowspan="2"
                width="15%"
                height="24"
                className="border border-[#FFFFFF]"
              >
                <b>Nhà cái</b>
              </th>
              <th
                rowspan="2"
                colSpan={1}
                width="5%"
                className="border border-[#FFFFFF]"
              >
                #
              </th>
              <th colSpan="3" className="border border-[#FFFFFF] p-2">
                <b>Tỷ lệ {location.name}</b>
              </th>
            </tr>
            <tr height="20" className="border border-[#FFFFFF]">
              {location.slug === "chau-a" ? (
                <>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF] p-1">
                    Chủ
                  </th>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    HDC
                  </th>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Khách
                  </th>
                </>
              ) : (<></>)}
              {location.slug === "tai-xiu" ? (
                <>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Tài
                  </th>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Kèo đấu
                  </th>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Xỉu
                  </th>
                </>
              ) : (<></>)}
              {location.slug === "chau-au" ? (
                <>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Chủ
                  </th>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Hòa
                  </th>
                  <th width="8%" className="border bg-[#FFFFFF] dark:bg-pure-black border-[#FFFFFF]">
                    Khách
                  </th>
                </>
              ) : (<></>)}
            </tr>
            {BANKER.map((item, index) => {
              const handicapOdd = data.handicap.find(
                (odd) => odd.companyId === item.value
              );
              const overUnderOdd = data.overUnder.find(
                (odd) => odd.companyId === item.value
              );
              const europeOdd = data.europeOdds.find(
                (odd) => odd.companyId === item.value
                  );
                  const handicapLiveOdds = filterCompanyId(
                    item.value,
                    groupByCompanyId(dataLiveOdd.liveHandicapOdds)
                  );
                  const overUnderLiveOdds = filterCompanyId(
                    item.value,
                    groupByCompanyId(dataLiveOdd.liveOverUnderOdds)
                  );
                  const europeLiveOdds = filterCompanyId(
                    item.value,
                    groupByCompanyId(dataLiveOdd.liveEuropeOdds)
                  );

                  return (
                    <React.Fragment key={index}>
                      <tr className={(index+1)  % 2 !== 0 ? 'bg-[#FFFFFF] dark:bg-pure-black' : 'bg-[#E6ECEE] dark:bg-dark-slate'}
                        style={{height: "20px"}}
                        id="tr_o_1_31"
                        name="earlyOdds"
                      >
                        <td className={`companyBg text-center`} rowSpan={3}>
                          <b>{item.name}</b>
                        </td>
                        <td className="ll rl lo-f2  text-center p-1">
                          {" "}
                          Sớm
                          
                        </td>
                        {location.slug === "chau-a" ? (
                          <>
                            <td
                              className={`hbg-td2r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="0.58"
                            >
                              {handicapOdd?.initialHome}
                            </td>
                            <td className={`hbg-td2r text-center font-semi-bold ${location.bgCell}`} data-o="0">
                              {handicapOdd?.initialHandicap}
                            </td>
                            <td
                              className={`rl hbg-td2r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="1.35"
                            >
                              {handicapOdd?.initialAway}
                            </td>
                          </>
                        ) : (<></>)}
                        {location.slug === "tai-xiu" ? (
                          <>
                            <td
                              className={`hbg-td1r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="9.40"
                              data-e="1"
                            >
                              {overUnderOdd?.initialOver}
                            </td>
                            <td
                              className={`hbg-td1r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="1.07"
                              data-e="1"
                            >
                              {overUnderOdd?.initialHandicap}
                            </td>
                            <td
                              className={`hbg-td1r rl text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="12.50"
                              data-e="1"
                            >
                              {overUnderOdd?.initialUnder}
                            </td>
                          </>
                        ) : (<></>)}
                        {location.slug === "chau-au" ? (
                          <>
                            <td
                              className={`hbg-td4r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="4.54"
                            >
                              {europeOdd?.initialHome}
                            </td>
                            <td className={`hbg-td4r text-center font-semi-bold ${location.bgCell}`} data-o="4.5">
                              {europeOdd?.initialDraw}
                            </td>
                            <td
                              className={`rl hbg-td4r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="0.08"
                            >
                              {europeOdd?.initialAway}
                            </td>
                          </>
                        ) : (<></>)}
                      </tr>
                      <tr className={(index+1)  % 2 !== 0 ? 'bg-[#FFFFFF] dark:bg-pure-black' : 'bg-[#E6ECEE] dark:bg-dark-slate'}
                        style={{height: "20px"}}
                        id="tr_o_1_31"
                        name="earlyOdds"
                      >

                        <td className="ll rl lo-f2 text-center p-1">
                          {" "}
                          Cuối
                        </td>
                        {location.slug === "chau-a" ? (
                          <>
                            <td
                              className={`hbg-td2r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="0.58"
                            >
                              {handicapOdd?.instantHome}
                            </td>
                            <td className={`hbg-td2r text-center font-semi-bold ${location.bgCell}`} data-o="0">
                              {handicapOdd?.instantHandicap}
                            </td>
                            <td
                              className={`rl hbg-td2r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="1.35"
                            >
                              {handicapOdd?.instantAway}
                            </td>
                          </>
                        ) : (<></>)}
                        {location.slug === "tai-xiu" ? (
                          <>
                            <td
                              className={`hbg-td1r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="9.40"
                              data-e="1"
                            >
                              {overUnderOdd?.instantOver}
                            </td>
                            <td
                              className={`hbg-td1r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="1.07"
                              data-e="1"
                            >
                              {overUnderOdd?.instantHandicap}
                            </td>
                            <td
                              className={`hbg-td1r rl text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="12.50"
                              data-e="1"
                            >
                              {overUnderOdd?.instantUnder}
                            </td>
                          </>
                        ) : (<></>)}
                        {location.slug === "chau-au" ? (
                          <>
                            <td
                              className={`hbg-td4r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="4.54"
                            >
                              {europeOdd?.instantHome}
                            </td>
                            <td className={`hbg-td4r text-center font-semi-bold ${location.bgCell}`} data-o="4.5">
                              {europeOdd?.instantDraw}
                            </td>
                            <td
                              className={`rl hbg-td4r text-center font-semi-bold ${location.bgCell}`}
                              name="oddsData"
                              data-o="0.08"
                            >
                              {europeOdd?.instantAway}
                            </td>
                          </>
                        ) : (<></>)}
                      </tr>
                      <tr className={(index+1)  % 2 !== 0 ? 'bg-[#FFFFFF] dark:bg-pure-black' : 'bg-[#E6ECEE] dark:bg-dark-slate'}
                        style={{height: "20px"}}
                        id="tr_o_1_31"
                        name="earlyOdds"
                      >
                        <td className="ll rl lo-f2 text-vibrant-red text-center p-1">
                          {" "}
                          Run
                        </td>
                        {location.slug === "chau-a" ? (
                          <>
                            <td
                              className={`hbg-td2r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="0.58"
                            >
                              {handicapLiveOdds?.instantHome}
                            </td>
                            <td className={`hbg-td2r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`} data-o="0">
                              {handicapLiveOdds?.instantHandicap}
                            </td>
                            <td
                              className={`rl hbg-td2r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="1.35"
                            >
                              {handicapLiveOdds?.instantAway}
                            </td>
                          </>
                        ) : (<></>)}
                        {location.slug === "tai-xiu" ? (
                          <>
                            <td
                              className={`hbg-td1r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="9.40"
                              data-e="1"
                            >
                              {overUnderLiveOdds?.instantOver}
                            </td>
                            <td
                              className={`hbg-td1r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="1.07"
                              data-e="1"
                            >
                              {overUnderLiveOdds?.instantHandicap}
                            </td>
                            <td
                              className={`hbg-td1r rl text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="12.50"
                              data-e="1"
                            >
                              {overUnderLiveOdds?.instantUnder}
                            </td>
                          </>
                        ) : (<></>)}
                        {location.slug === "chau-au" ? (
                          <>
                            <td
                              className={`hbg-td4r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="4.54"
                            >
                              {europeLiveOdds?.instantHome}
                            </td>
                            <td className={`hbg-td4r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`} data-o="4.5">
                              {europeLiveOdds?.instantDraw}
                            </td>
                            <td
                              className={`rl hbg-td4r text-center font-semi-bold bg-[#F0F0F0] dark:bg-pure-black`}
                              name="oddsData"
                              data-o="0.08"
                            >
                              {europeLiveOdds?.instantAway}
                            </td>
                          </>
                        ) : (<></>)}
                      </tr>
                    </React.Fragment>
                  );
            })}
            </tbody>
          </table>
        </div>
      </div>
    ) : (<NoData/>)
  );
};

export default React.memo(OddTableAnalysis);
